import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const auth = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
};

export const feriaFotoPublicUrl = (archivo) => {
  if (!archivo || typeof archivo !== "string") return null;
  const base = (API_URL || "").replace(/\/$/, "");
  return `${base}/uploads/ferias/${encodeURIComponent(archivo)}`;
};

export const getFerias = async () => {
  const { data } = await axios.get(`${API_URL}/api/ferias`, {
    headers: auth(),
  });
  return data;
};

export const createFeria = async (body) => {
  const { data } = await axios.post(`${API_URL}/api/ferias`, body, {
    headers: auth(),
  });
  return data;
};

export const updateFeria = async (id, body) => {
  const { data } = await axios.put(`${API_URL}/api/ferias/${id}`, body, {
    headers: auth(),
  });
  return data;
};

export const deleteFeria = async (id) => {
  const { data } = await axios.delete(`${API_URL}/api/ferias/${id}`, {
    headers: auth(),
  });
  return data;
};

export const createFeriaEdicion = async (feriaId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/${feriaId}/ediciones`,
    body,
    { headers: auth() },
  );
  return data;
};

export const deleteFeriaEdicion = async (id) => {
  const { data } = await axios.delete(`${API_URL}/api/ferias/ediciones/${id}`, {
    headers: auth(),
  });
  return data;
};

export const getFeriaEdicion = async (id) => {
  const { data } = await axios.get(`${API_URL}/api/ferias/ediciones/${id}`, {
    headers: auth(),
  });
  return data;
};

export const updateFeriaEdicion = async (id, body) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/ediciones/${id}`,
    body,
    { headers: auth() },
  );
  return data;
};

export const updateFeriaAsistentes = async (id, userIds) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/ediciones/${id}/asistentes`,
    { userIds },
    { headers: auth() },
  );
  return data;
};

export const linkFeriaProveedor = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/proveedores`,
    body,
    { headers: auth() },
  );
  return data;
};

export const createFeriaProveedorNuevo = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/proveedores/nuevo`,
    body,
    { headers: auth() },
  );
  return data;
};

export const deleteFeriaProveedor = async (id) => {
  await axios.delete(`${API_URL}/api/ferias/proveedores/${id}`, {
    headers: auth(),
  });
};

export const updateFeriaProveedor = async (id, body) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/proveedores/${id}`,
    body,
    { headers: auth() },
  );
  return data;
};

export const uploadFeriaProveedorFoto = async (id, file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(
    `${API_URL}/api/ferias/proveedores/${id}/foto`,
    form,
    {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
    },
  );
  return data;
};

export const addFeriaMaterial = async (edicionId, body) => {
  const { data } = await axios.post(
    `${API_URL}/api/ferias/ediciones/${edicionId}/materiales`,
    body,
    { headers: auth() },
  );
  return data;
};

export const updateFeriaMaterial = async (id, body) => {
  const { data } = await axios.put(
    `${API_URL}/api/ferias/materiales/${id}`,
    body,
    {
      headers: auth(),
    },
  );
  return data;
};

export const deleteFeriaMaterial = async (id) => {
  await axios.delete(`${API_URL}/api/ferias/materiales/${id}`, {
    headers: auth(),
  });
};

export const extractFeriaFoto = async (file, kind) => {
  const form = new FormData();
  form.append("file", file);
  form.append("kind", kind);
  const { data } = await axios.post(`${API_URL}/api/ferias/extract`, form, {
    headers: { ...auth(), "Content-Type": "multipart/form-data" },
  });
  return data;
};
